import { render } from "./list-user.vue?vue&type=template&id=87b78388&scoped=true"
import script from "./list-user.vue?vue&type=script&lang=js"
export * from "./list-user.vue?vue&type=script&lang=js"

import "./list-user.vue?vue&type=style&index=0&id=87b78388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b78388"]])

export default __exports__